import { getDefaultClient } from '../../factory';
// @endpoint POST /entity/:app_id/:entity_id/row/:row_id/comment-add
// @controller UserAction.EntityAddComment
export async function addEntityComment(appId, entityId, rowId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/row/${rowId}/comment-add`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/import-ai-config
// @controller UserAction.EntityAIImportConfig
export async function configEntityAIImport(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/import-ai-config`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/bulk-update
// @controller UserAction.EntityBulkUpdate
export async function updateEntityBulk(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/bulk-update`, data);
}
// @endpoint POST /ingress/:app_id/:ingress_hash_id/bulk-update/save-as
// @controller UserAction.EntityBulkUpdateSaveAs
export async function saveEntityBulkUpdateAs(appId, ingressHashId, data) {
    return getDefaultClient().post(`/ingress/${appId}/${ingressHashId}/bulk-update/save-as`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/row/:row_id/comment-delete
// @controller UserAction.EntityDelComment
export async function deleteEntityComment(appId, entityId, rowId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/row/${rowId}/comment-delete`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/row/:row_id/action/:action
// @controller UserAction.EntityDoAction
export async function doEntityAction(appId, entityId, rowId, action, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/row/${rowId}/action/${action}`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/convert/:action_code
// @controller UserAction.EntityDoFsmAction
export async function doEntityFsmAction(appId, entityId, actionCode, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/convert/${actionCode}`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/export
// @controller UserAction.EntityExport
export async function exportEntity(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/export`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/row/:row_id/comment-query
// @controller UserAction.EntityGetComments
export async function getEntityComments(appId, entityId, rowId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/row/${rowId}/comment-query`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/row/:row_id/log-query
// @controller UserAction.EntityGetLogs
export async function getEntityLogs(appId, entityId, rowId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/row/${rowId}/log-query`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/import
// @controller UserAction.EntityImport
export async function importEntity(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/import`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/import-prepare
// @controller UserAction.EntityImportPrepare
export async function prepareEntityImport(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/import-prepare`, data);
}
// @endpoint GET /entity/:app_id/:entity_id
// @controller UserAction.EntityInfo
export async function getEntityInfo(appId, entityId) {
    return getDefaultClient().get(`/entity/${appId}/${entityId}`);
}
// @endpoint POST /entity/:app_id/:entity_id/invoke-batch-operator
// @controller UserAction.EntityInvokeBatchOperator
export async function invokeEntityBatchOperator(appId, entityId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/invoke-batch-operator`, data);
}
// @endpoint POST /entity/:app_id/:entity_id/invoke/:action_id
// @controller UserAction.EntityInvokeHook
export async function invokeEntityHook(appId, entityId, actionId, data) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/invoke/${actionId}`, data);
}
// @endpoint GET /entity/:app_id/:entity_id/row/:row_id/process-map
// @controller UserAction.EntityProcessMap
export async function getEntityProcessMap(appId, entityId, rowId) {
    return getDefaultClient().get(`/entity/${appId}/${entityId}/row/${rowId}/process-map`);
}
// @endpoint POST /entity/:app_id/:entity_id/print-templates
// @controller UserAction.GetPrintTemplates
export async function getEntityPrintTemplates(appId, entityId) {
    return getDefaultClient().post(`/entity/${appId}/${entityId}/print-templates`);
}
